<template>
  <div>
    <div ref="top" class="observer"></div>
    <slot></slot>
    <div ref="bottom" class="observer"></div>
  </div>
</template>

<script>
export default {
  props: ["value", "offset"],

  data() {
    return {
      topPosition: 1,
      bottomPosition: 1,

      topOffset: 0,
      bottomOffset: 0,

      rootTop: 0,
      currentTime: performance.now(),
    };
  },

  watch: {
    topPosition(v) {
      this.$emit("input", this.getParams());
      if (v === 0) {
        this.$emit("topInView");
      }
    },
    bottomPosition(v, old) {
      this.$emit("input", this.getParams());
      if (old === 1 && v === 0) this.$emit("bottomInView");
    },
    topOffset() {
      this.$emit("input", this.getParams());
    },
    bottomOffset() {
      this.$emit("input", this.getParams());
    },
  },

  mounted() {
    this._root = document.querySelector(".layout");
    this.rootTop = this._root.getBoundingClientRect().top;
    const resizeHandler = () => {
      this.rootTop = this._root.getBoundingClientRect().top;
    };
    window.addEventListener("resize", resizeHandler);

    const topObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) this.topPosition = 0;
        else if (entry.boundingClientRect.top < entry.rootBounds.top) this.topPosition = -1;
        else this.topPosition = 1;
      },
      {
        root: this._root,
      },
    );
    const bottomObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) this.bottomPosition = 0;
      else if (entry.boundingClientRect.top < 0) this.bottomPosition = -1;
      else this.bottomPosition = 1;
    });

    topObserver.observe(this.$refs.top);
    bottomObserver.observe(this.$refs.bottom);

    if (this.offset) {
      this._root.addEventListener("scroll", this.onScroll);
    }
  },

  beforeDestroy() {
    // this.topObserver.unobserve(this.$refs.top);
    // this.bottomObserver.unobserve(this.$refs.bottom);
    // window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll() {
      const now = performance.now();
      if (now - this.currentTime >= 30) {
        const rect = this.$el.getBoundingClientRect();
        const rootRect = this._root.getBoundingClientRect();

        if (this.topPosition === -1) {
          this.topOffset = -1 * rect.top + rootRect.top;
        } else {
          this.topOffset = 0;
        }

        if (this.bottomPosition === 1) {
          this.bottomOffset = rect.bottom - document.body.offsetHeight;
        } else {
          this.bottomOffset = 0;
        }
        this.currentTime = now;
      }
    },
    getParams() {
      return {
        top: this.topPosition,
        bottom: this.bottomPosition,
        topOffset: this.topOffset,
        bottomOffset: this.bottomOffset,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.observer {
  width: 100%;
  height: 1px;
}
</style>
